'use client';

import { IconDefinition } from 'stylus-icons/types';
import { IconDefinition as FontAwesomeIconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { cva } from 'class-variance-authority';
import { forwardRef } from 'react';
import * as React from 'react';
import { cn } from '../utils/cn';

export interface IconProps extends Omit<FontAwesomeIconProps, 'icon' | 'size'> {
  icon: IconDefinition;
}

const iconStyles = cva('inline-flex shrink-0 items-center justify-center');

/**
 * A flexible icon component that supports both FontAwesome icons and custom SVG icons
 * using a unified API that matches FontAwesome's IconDefinition pattern.
 * @see {@link https://stylus.design/icon}
 */
export const Icon = forwardRef<SVGSVGElement, IconProps>(({ className, icon, ...props }, ref) => {
  return (
    <FontAwesomeIcon
      ref={ref}
      icon={icon as FontAwesomeIconDefinition}
      color={props.color ?? 'currentColor'}
      className={cn(iconStyles(), className)}
      {...props}
    />
  );
});

export type { IconDefinition };
